import { getFilterDisplayName } from "../../utils/getFilterDisplayName";
import { XClose } from "untitledui-js-base";
import { FC } from "react";

interface Props {
  filter: string;
  onRemove: () => void;
  /** Longer labels such as date ranges ("Submitted: Oct 1, 2026 – Oct 31, 2026"). */
  wide?: boolean;
}

export const FilterBadge: FC<Props> = ({ filter, onRemove, wide = false }) => {
  return (
    <div className="py-2 px-4 items-center border border-alpha-40 bg-primary-20 text-primary-600 text-xs font-medium rounded-lg flex gap-1.5 justify-between">
      <p
        className={wide ? "max-w-[280px] truncate" : "max-w-[100px] truncate"}
        title={getFilterDisplayName(filter)}
      >
        {getFilterDisplayName(filter)}
      </p>
      <button onClick={onRemove}>
        <XClose size="18" className="stroke-primary-600" />
      </button>
    </div>
  );
};
